(() => {
  const mobile = matchMedia('(max-width:749px)');
  const boundVideos = new WeakSet();
  const bind = () => {
    document.querySelectorAll('.product-details').forEach(details => {
      const subtitle = details.querySelector('.neuer-product-subtitle');
      if (!subtitle) return;
      const style = getComputedStyle(subtitle);
      details.style.setProperty('--neuer-collection-size', style.fontSize);
      details.style.setProperty('--neuer-collection-font', style.fontFamily);
      details.style.setProperty('--neuer-collection-weight', style.fontWeight);
    });
    document.querySelectorAll('[data-neuer-desktop-fade] video').forEach(video => {
      if (boundVideos.has(video)) return;
      boundVideos.add(video);
      const root = video.closest('[data-neuer-desktop-fade]');
      const copy = root.querySelector('.neuer-editorial-footer__content');
      const fade = () => {
        if (!mobile.matches || !copy || !Number.isFinite(video.duration)) return;
        const start = Number(root.dataset.neuerDesktopFade) || 78;
        const duration = Math.max(.1, video.duration * (100 - start) / 100);
        copy.style.setProperty('--nd-video-copy-opacity', String(Math.max(0,Math.min(1,(video.duration-video.currentTime)/duration))));
      };
      video.addEventListener('timeupdate',fade);
      mobile.addEventListener('change',fade);
      fade();
    });
  };
  document.addEventListener('shopify:section:load',bind);
  mobile.addEventListener('change',bind);
  let resizeFrame;
  window.addEventListener('resize',()=>{cancelAnimationFrame(resizeFrame);resizeFrame=requestAnimationFrame(bind);},{passive:true});
  document.fonts.ready.then(bind);
  bind();
})();
